<script>
import { updateHotelGoodsTag, deleteHotelGoodsTag } from '@/src/apis/hotelGoodsTag'

const TAG_COLOR_OPTIONS = [{ label: '預設', value: '' }, { label: '亮綠', value: 'success' }, { label: '灰色', value: 'info' }, { label: '黃色', value: 'warning' }, { label: '紅色', value: 'danger' }]

export default {
  props: {
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
    currentActiveIndex: {
      default: '',
    },
    itemIndex: {
      type: Number,
    },
  },
  data() {
    return {
      submitData: { ...this.defaultValue },
      tagColorOptions: TAG_COLOR_OPTIONS,
      tryingRemove: false,
      tryingStore: false,
    }
  },
  methods: {
    async tryToStore() {
      try {
        this.tryingStore = true
        const payload = { name: this.submitData.name, color: this.submitData.color }
        await updateHotelGoodsTag(this.submitData.id, payload)
        this.$message({ message: '儲存成功', type: 'success' })
        this.$emit('refresh')
        this.$emit('update', '')
      } catch (error) {
        console.error(error)
      } finally {
        this.tryingStore = false
      }
    },
    async tryToRemove() {
      try {
        this.tryingRemove = true
        await deleteHotelGoodsTag(this.submitData.id)
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      } finally {
        this.tryingRemove = false
      }
    },
    reset() {
      this.submitData = { ...this.defaultValue }
      this.$emit('update', '')
    },
    updateActiveIndex() {
      this.$emit('update', this.itemIndex)
    },
  },
}
</script>

<template>
  <el-form-item>
    <!-- 編輯模式 -->
    <div v-if="itemIndex === currentActiveIndex">
      <div style="text-align: right; margin-bottom: 6px;">
        <el-button class="is-round" size="mini" type="text" @click="reset">
          <BaseIcon name="trash-alt" class="text-primary" />
          取消
        </el-button>
        <el-button v-loading="tryingStore" class="is-round" size="mini" type="text" @click="tryToStore">
          <BaseIcon name="check" class="text-primary" />
          儲存
        </el-button>
      </div>
      <el-input v-model="submitData.name" placeholder="標籤名稱" style="margin-bottom: 10px;" />
      <!-- 顏色選擇：5 個固定 type 按鈕 -->
      <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 6px; margin-bottom: 6px;">
        <span style="font-size: 12px; color: #909399; white-space: nowrap;">顏色：</span>
        <el-tag
          v-for="opt in tagColorOptions"
          :key="opt.value || 'none'"
          :type="opt.value || undefined"
          size="medium"
          :effect="submitData.color === opt.value ? 'dark' : 'plain'"
          style="cursor: pointer;"
          @click="submitData.color = opt.value"
          >{{ opt.label }}</el-tag
        >
      </div>
    </div>

    <!-- 顯示模式 -->
    <div v-else :class="$style.displayRow">
      <div :class="$style.displayPrepend">
        <el-tag :type="submitData.color || undefined" size="mini">{{ submitData.name }}</el-tag>
      </div>
      <div :class="$style.displayName">{{ submitData.name }}</div>
      <div v-if="currentActiveIndex === ''" :class="$style.displayAppend">
        <el-button size="mini" type="text" class="isPrimary fs-xl mr-2" @click="updateActiveIndex">
          <BaseIcon name="edit" />
        </el-button>
        <el-button v-loading="tryingRemove" size="mini" type="text" class="isPrimary fs-xl ml-2" @click="tryToRemove">
          <BaseIcon name="trash-alt" />
        </el-button>
      </div>
    </div>
  </el-form-item>
</template>

<style lang="scss" module>

.displayRow {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
}

.displayPrepend {
  display: flex;
  align-items: center;
  padding: 0 10px 0 0;
  height: 100%;
  white-space: nowrap;
}

.displayName {
  flex: 1;
  padding: 0 10px;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.displayAppend {
  display: flex;
  align-items: center;
  padding: 0 6px;
  height: 100%;

  button.el-button {
    &.isPrimary {
      color: $color-primary;

      &:hover {
        color: $color-primary-light;
      }
    }
  }
}
</style>
